import "./DownloadPage.scss";
import AppContainer from "../../../components/app-container/AppContainer";
import pdfIcon from "../../../../resources/images/download_icon.png";
import pdfIconDownload from "../../../../resources/images/pdf_icon.png";
import React from "react";
import { useTranslation } from "react-i18next";

interface Downloads {
    TEXT: string;
    LINK: string;
}

export const DownloadPage = () => {
    const { t } = useTranslation();

    const downloads = t("DOWNLOAD_PAGE.DOWNLOADS", { returnObjects: true }) as Downloads[];

    return (
        <>
            <AppContainer header={{ menuLoginEnabled: true }}>
                <div className="download-page">
                    <h1>{t("DOWNLOAD_PAGE.HEADLINE")}</h1>
                    <p>{t("DOWNLOAD_PAGE.INTRO")}</p>

                    {downloads.map((download, index) => (
                        <section key={index}>
                            <ul>
                                <li>
                                    <span>
                                        <img src={pdfIcon} alt="Link Download Document" />{" "}
                                        <a href={download.LINK} target="_blank">
                                            {download.TEXT}
                                        </a>
                                    </span>
                                    <span>
                                        <img src={pdfIconDownload} alt="Downloas Document" />
                                        <a href={download.LINK} target="_blank">
                                            Download
                                        </a>
                                    </span>
                                </li>
                            </ul>
                        </section>
                    ))}
                </div>
            </AppContainer>
        </>
    );
};
